export interface RadioProps {
  label: string
  value: string
  checked?: boolean
  disabled?: boolean
  name?: string
  size?: 'sm' | 'md' | 'lg'
  labelStyles?: string
  onChange?: (value: string) => void
}

export default function Radio({
  label,
  value,
  checked,
  disabled,
  name,
  onChange,
  size = 'md',
  labelStyles = '',
}: RadioProps) {
  let sizeStyles = ''
  let labelSizeStyles = ''

  switch (size) {
    case 'sm':
      sizeStyles = 'h-4 w-4'
      labelSizeStyles = 'text-sm'
      break
    case 'lg':
      sizeStyles = 'h-5 w-5'
      labelSizeStyles = 'text-lg'
      break
    case 'md':
    default:
      sizeStyles = 'h-4 w-4 mr-2'
      labelSizeStyles = 'text-base'
      break
  }

  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'

  return (
    <div className='flex items-center'>
      <input
        type='radio'
        id={value}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => onChange?.(value)}
        className={`custom-radio ${sizeStyles} ${disabledStyles}`}
      />
      <label
        htmlFor={value}
        className={`${labelSizeStyles} text-cta font-sans font-medium ${labelStyles} ${disabledStyles}`}
      >
        {label}
      </label>
    </div>
  )
}
